// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1e6zn","options":"AnswerScale_options__F0Njg","selected":"AnswerScale_selected__2Gba2"};